import DosApprovalList from './component';
import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';

export default ({ getState }) => ({
  path: 'dos-approval',
  component: DosApprovalList,
  canAccess: () =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.ApproveComment),
  tabs: {
    hidden: true,
  },
  sessionNav: {
    hidden: true,
  },
  actionButtons: {
    hidden: true,
  },
  breadcrumbLabels: 'DOS Approval',
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/DosApprovalList/routes.js